var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVenezuela(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8093 17.2174C23.5722 15.6397 24 13.8699 24 12C24 10.1301 23.5722 8.36025 22.8093 6.78262L12 5.73914L1.19072 6.78262C0.427828 8.36025 0 10.1301 0 12C0 13.8699 0.427828 15.6397 1.19072 17.2174L12 18.2609L22.8093 17.2174Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C16.7575 24 20.8683 21.2313 22.8093 17.2174H1.19072C3.13172 21.2313 7.24247 24 12 24Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7828 14.3556L20.149 14.8508L20.4241 15.6065L19.7572 15.1568L19.1234 15.652L19.345 14.8788L18.6782 14.429L19.482 14.401L19.7039 13.6278L19.979 14.3836L20.7828 14.3556Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1597 11.5445L18.7336 12.2266L19.2507 12.8427L18.4702 12.6483L18.0439 13.3303L17.9877 12.5279L17.2072 12.3333L17.9531 12.0319L17.8971 11.2295L18.414 11.8458L19.1597 11.5445Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6732 9.45792L16.506 10.2447L17.2026 10.6469L16.4026 10.7312L16.2354 11.5178L15.9082 10.7831L15.1082 10.867L15.706 10.3288L15.3789 9.59409L16.0754 9.99618L16.6732 9.45792Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6229 8.34782L13.735 9.14437L14.527 9.28396L13.8041 9.63675L13.9161 10.4332L13.3574 9.85462L12.6343 10.2072L13.012 9.49692L12.4532 8.91839L13.2454 9.05803L13.6229 8.34782Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.377 8.34782L10.7547 9.05803L11.5467 8.91829L10.9881 9.49706L11.3656 10.2073L10.6427 9.85462L10.0838 10.4331L10.1959 9.63675L9.47297 9.28415L10.2651 9.14437L10.377 8.34782Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3268 9.45792L7.92464 9.99618L8.62106 9.59409L8.29401 10.3291L8.89172 10.8672L8.0918 10.7831L7.76452 11.5178L7.5975 10.7311L6.79753 10.6471L7.49409 10.2448L7.3268 9.45792Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.84022 11.5445L5.58614 11.8458L6.10298 11.2296L6.04706 12.0322L6.79275 12.3336L6.01232 12.528L5.95612 13.3303L5.53003 12.6483L4.74951 12.8428L5.26654 12.2266L4.84022 11.5445Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.21722 14.3556L4.02122 14.3836L4.29619 13.6279L4.51814 14.4011L5.3219 14.4292L4.65506 14.879L4.87669 15.6522L4.24294 15.157L3.57604 15.6066L3.85115 14.8508L3.21722 14.3556Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8093 6.78263C20.8683 2.76867 16.7575 0 12 0C7.24247 0 3.13172 2.76867 1.19072 6.78263H22.8093Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenezuela);
export default __webpack_public_path__ + "static/media/venezuela.4d96b65cf7b860d85f40cd8dbdaaf8f3.svg";
export { ForwardRef as ReactComponent };